import { put, takeLatest, call } from 'redux-saga/effects';
import * as venueService from '../../../services/venueService';
import {
  ADD_VENUE_LOG,
  ADD_VENUE_LOG_SUCCESS,
  ADD_VENUE_LOG_ERROR,
} from '../../actions/venue';

function* addVenueLogSaga(action) {
  try {
    const data = yield call(venueService.AddVenueLog, action.payload);
    yield put({
      type: ADD_VENUE_LOG_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: ADD_VENUE_LOG_ERROR,
      error: error.data,
    });
  }
}

export function* addVenueLogSagaWatcher() {
  yield takeLatest(ADD_VENUE_LOG, addVenueLogSaga);
}
